import React from 'react';
import LegalLandingPage from './LegalLandingPage';
import { PRIVACY_POLICY } from './legalContent';

const PrivacyPolicy: React.FC = () => (
  <LegalLandingPage
    doc={PRIVACY_POLICY}
    footerLinks={[
      { to: '/terms-and-conditions', label: 'Terms and Conditions' },
      { to: '/cookies-policy', label: 'Cookies Policy' },
    ]}
  />
);

export default PrivacyPolicy;
